import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Exam } from '../../../types';
import ExamRepository from '../../exams/repository/ExamRepository';
import ExamLineSelector from './ExamLineSelector';

interface UpdateAttendanceDialogProps {
  exam?: Exam;
  open: boolean;
  onClose: () => void;
}

const UpdateAttendanceDialog = (props: UpdateAttendanceDialogProps) => {
  const notifications = useSnackbar();
  const history = useHistory();

  const [selectedExamLineIds, setSelectedExamLineIds] = useState<string[]>(() =>
    props.exam
      ? props.exam.examLines
          .filter((el) => el.delegateIsPresent)
          .map((el) => el.id)
      : [],
  );

  const handleExamLinesChange = (examLineIds: string[]) => {
    setSelectedExamLineIds(examLineIds);
  };

  const handleSubmit = async () => {
    if (!props.exam) {
      return;
    }

    new ExamRepository()
      .updateAttendance(props.exam.id, selectedExamLineIds)
      .then(() => {
        notifications.enqueueSnackbar(
          'De beschikbaarheid is succesvol aangepast.',
          { variant: 'success' },
        );
        history.go(0);
      })
      .catch(() => {
        notifications.enqueueSnackbar(
          'Fout bij het aanpassen van de beschikbaarheid.',
          { variant: 'error' },
        );
      });
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle disableTypography>
        <Typography variant="h2">Beschikbaarheid aanpassen</Typography>
      </DialogTitle>
      <DialogContent>
        <ExamLineSelector
          examLines={props.exam?.examLines || []}
          selectedExamLineIds={selectedExamLineIds}
          onChange={handleExamLinesChange}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Opslaan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateAttendanceDialog;
